module.exports = __webpack_public_path__ + "static/img/division_4.ccf978d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/fortnite/division_4.svg
// module id = +Ydy
// module chunks = 35